<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-card>
      <v-card-text class="pa-5">
        <v-row>
          <v-col>
            <source-form :errors="errors" @onSubmit="submit"/>
          </v-col>
        </v-row>
        <v-snackbar
          v-model="snackbarSuccess"
          :timeout="timeout"
          color="success"
        >
          Сохранено

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarSuccess = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
        <v-snackbar
          v-model="snackbarError"
          :timeout="timeout"
          color="error"
        >
          {{ this.errors }}

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              @click="snackbarError = false"
              color="red"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import SourceForm from '../../../components/sources/SourceForm';
import {Source} from '../../../models/source';

export default {
  name: 'Create',
  components: {SourceForm},
  data: () => ({
    errors: {},
    snackbarSuccess: false,
    snackbarError: false,
    timeout: 2000,
    page: {
      title: "Создание источники"
    },
    breadcrumbs: [
      {
        text: "Админ панель",
        disabled: false,
        to: '/'
      },
      {
        text: "Источники",
        disabled: true,
        to: '/sources'
      },
      {
        text: "Создание",
        disabled: true,
        to: '/sources/create'
      },
    ]
  }),
  methods: {
    async submit(form, isNeedRedirect) {
      try {
        this.errors = {};
        const sources = await Source.$query().store(form);
        this.snackbarSuccess = true;

        if (isNeedRedirect) {
          await this.$router.push({name: 'sources-index'});
        } else {
          await this.$router.push({name: 'sources-edit', params: {id: sources.$attributes.id}});
        }
      } catch (e) {
        if (e.response?.data) {
          this.errors = e.response.data.errors
        }
        this.snackbarError = true;
        throw e;
      }
    },
  },
};
</script>
